import React from 'react';
import Hero from './components/Hero';
import Header from './components/Header';
import OurStory from './components/OurStory';
import EventDetails from './components/EventDetails';
import Transferencia from './components/Transferencia';
import RSVPForm from './components/RSVPForm';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import WelcomeLetter from './components/WelcomeLetter';

function App() {
  return (
    // <div className="App min-h-screen bg-gradient-to-br from-cream-200 to-sand-200 overflow-x-hidden w-full">
    <div className="App min-h-screen bg-gradient-to-br from-olive-300 to-forest-700 overflow-x-hidden w-full">
    <WelcomeLetter />
      <Header />
      <Hero />
      <OurStory />
      <EventDetails />
      <Transferencia />
      <RSVPForm />
      <Gallery />
      <Footer />
    </div>
  );
}

export default App;
